import Request from "utils/requests/api";
import initializeConfig from "utils/requests/api.config";

export interface IRequestVehicleDashboard {
  locationId: number;
  _size: number;
  _page: number;
  filter: string;
  processIds?: number[];
  saleChannelIds?: number[];
  vehicleStepStatus?: number;
  ascending?: string;
}

export const BASE_URL_YARD_REGISTERS = async () => {
  const { gates } = await initializeConfig();
  return `${gates}yard-registers`;
};

export const getVehicleDashboard = async ({ _size, _page, locationId, filter, processIds, ascending, saleChannelIds, vehicleStepStatus }: IRequestVehicleDashboard) => {
  const baseUrlYardRegisters = await BASE_URL_YARD_REGISTERS();
  return (await Request).get(`${baseUrlYardRegisters}:paginated`, {
    locationId,
    _size,
    _page,
    filter,
    processIds,
    saleChannelIds,
    vehicleStepStatus,
    ascending,
  });
};
